import { UseMutationResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { createContext } from "react";

import { ChannelType } from "@/types/response/ChannelType";
import { PagedResponse } from "@/types/response/PagedResponse";
import { ValidationErrorResponse } from "@/types/response/ValidationResponse";

export interface UpdateChannelCurrentMonthPayload {
  channelId: string;
  payload: { budget: number; clientId2: string };
}

export interface UpdateChannelMonthlyPayload {
  channelId: string;
  payload: { budget: number; clientId2: string };
}

export type ChannelsContextType = {
  channel: ChannelType | undefined;
  clientChannels: PagedResponse<ChannelType> | undefined;
  clientChannelsLoading: boolean;
  clientChannelsFetching: boolean
  updateCurrentMonthBudget: UseMutationResult<
    void,
    AxiosError<ValidationErrorResponse>,
    UpdateChannelCurrentMonthPayload
  >;
  updateMonthlyBudget: UseMutationResult<
    void,
    AxiosError<ValidationErrorResponse>,
    UpdateChannelMonthlyPayload
  >;
}

export const ChannelsContext = createContext<ChannelsContextType | undefined>(undefined);
